<!--The content below is only a placeholder and can be replaced.-->
<app-navbar></app-navbar>
<div class="container">
  <div class="pt-4 pb-4"></div>
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
